import { colours } from "./colours";
import { Bar } from "react-chartjs-2";
import { Placeholder } from "react-bootstrap";
import { useMemo, memo } from "react";

const getRenderOrder = (key) => {
  if (key === 'Interruptions') return 1;
  else if (key === 'Positive') return 2;
  else if (key === 'Negative') return 1;
  else if (key === 'Neutral') return 3;
  else if (key.indexOf('Customer') >= 0) return 5;
  else return 10;
}

const LoudnessChartComponent = ({ loudnessData, speakerLabels }) => {
  const datasets = useMemo(() => {
    if (!loudnessData || !speakerLabels) {
      return [];
    }

    const result = [];
    Object.keys(speakerLabels).forEach((key) => {
      if (key in loudnessData && loudnessData[key] && Array.isArray(loudnessData[key]) && loudnessData[key].length > 0) {
        // Filter out any invalid data points (must have valid x and y coordinates)
        const validData = loudnessData[key].filter(point =>
          point &&
          typeof point === 'object' &&
          'x' in point &&
          'y' in point &&
          typeof point.x === 'number' &&
          typeof point.y === 'number' &&
          !isNaN(point.x) &&
          !isNaN(point.y)
        );

        // Only create dataset if we have valid data points
        if (validData.length > 0) {
          result.push({
            label: speakerLabels[key] || key,
            data: validData,
            backgroundColor: colours[key] || '#6B7280',
            borderColor: colours[key] || '#6B7280',
            barPercentage: 1.0,
            categoryPercentage: 1.0,
            borderSkipped: true,
            order: getRenderOrder(speakerLabels[key]),
            type: "bar",
            xAxisID: 'x'
          });
        }
      }
    });
    return result;
  }, [loudnessData, speakerLabels]);

  // If no data available, show placeholder
  if (!loudnessData || !speakerLabels) {
    return <Placeholder />
  }

  // If no valid datasets, show message
  if (datasets.length === 0) {
    return (
      <div className="text-center py-4 text-gray-500 text-sm">
        No loudness data available
      </div>
    );
  }

  const chartKey = `loudness-chart-${datasets.length}`;

  return (
    <Bar
      key={chartKey}
      redraw={true}
      aria-label="This is a chart showing speaker and caller loudness, interruptions, silence, and sentiment per second."
      height={70}
      data={{
        /*labels: Object.keys(speakerLabels),*/
        datasets: datasets,
        /*datasets: [
          {
            label: "Loudness",
            data: data,
            backgroundColor: colours[caller],
            borderColor: colours[caller],
            barThickness: 20,
            order: 1,
          },
          {
            data: interruptions,
            label: "Interruption",
            backgroundColor: "rgba(252,232,83,0.6)",
            skipNull: true,
            type: "bar",
            barThickness: 30,
            order: 1,
          },
        ],*/
      }}
      options={{
        scales: {
          x: {
            type: "linear",
            stacked: true,
            offset: false,
            display: true,
            position: "left",
            title: { text: "Seconds", display: true },
          },
          y: {
            display: true,
            stacked: false,
            offset: false,
            position: "left",
            title: { text: "Decibels", display: true },
          },
        },
        plugins: {
          legend: {
            display: true,
            labels: {
              filter: function (item, chart) {
                if (item.text.includes('Positive') ||
                  item.text.includes('Negative') ||
                  item.text.includes('Neutral')
                ) return false;
                return true;
              }
            }
          },
        },
      }}
    />
  );
};

export const LoudnessChart = memo(LoudnessChartComponent);
